/******/ (() => {
  // webpackBootstrap
  window.PXUTheme.jsTopBar = {
    init: function ($section) {
      var $slider = $section.find("[data-top-bar-slider]");

      if (!$slider.length || typeof $.fn.flickity === "undefined") {
        return;
      }

      if ($slider.hasClass("flickity-enabled")) {
        $slider.flickity("destroy");
      }

      $slider.flickity({
        cellAlign: "left",
        contain: true,
        draggable: true,
        wrapAround: $slider.data("top-bar-slider-wrap") === true,
        prevNextButtons: $slider.data("top-bar-slider-arrows") === true,
        pageDots: $slider.data("top-bar-slider-dots") === true,
        autoPlay: $slider.data("top-bar-slider-autoplay"),
        pauseAutoPlayOnHover: $slider.data("top-bar-slider-pause") === true,
      });

      $slider.on("settle.flickity", function () {
        $slider.flickity("resize");
      });
    },
    unload: function ($section) {
      var $slider = $section.find("[data-top-bar-slider].flickity-enabled");

      if ($slider.length) {
        $slider.flickity("destroy");
      }
    },
  };

  /******/
})();
